import { FC, useState } from "react";
import image from "../../Assets/TalentOnDemand/phone-laptop.png";
const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
        <path
            d="M17.2322 36.7678C18.2085 37.7441 19.7915 37.7441 20.7678 36.7678L36.6777 20.8579C37.654 19.8816 37.654 18.2986 36.6777 17.3223C35.7014 16.346 34.1184 16.346 33.1421 17.3223L19 31.4645L4.85786 17.3223C3.88155 16.346 2.29864 16.346 1.32233 17.3223C0.346019 18.2986 0.346019 19.8816 1.32233 20.8579L17.2322 36.7678ZM16.5 -1.09278e-07L16.5 35L21.5 35L21.5 1.09278e-07L16.5 -1.09278e-07Z"
            fill="black"
        />
    </svg>
);

const TalentOnDemandFeaturesOurPlatform: FC = () => {
    const stepsData = [
        {
            id: 1,
            title: "Hiring Management Dashboard",
            body: "Simplify the hiring process with our user-friendly platform, enabling companies of all sizes to efficiently manage and track candidate progress through their applications.",
            icon: "1",
        },
        {
            id: 2,
            title: "Personality Assessment",
            body: "Utilize our proprietary 7-point personality assessment, built by leading experts, to make informed hires by comparing applicants with current employees and identifying the best personality matches for your workplace.",
            icon: "2",
        },
        {
            id: 3,
            title: "WorXspace",
            body: "Candidates can create dynamic digital resumes with personalized presentation pages, allowing employers to gain a deeper understanding of each candidate beyond the traditional resume.",
            icon: "3",
        },
        {
            id: 4,
            title: "Self Interviews",
            body: "Leverage video technology for unique self-presentation, enabling candidates to showcase their skills and personality in a more engaging way.",
            icon: "4",
        },
        {
            id: 5,
            title: "AI-Powered",
            body: "Optimizations: Automate tasks and optimize matching processes with our AI technology, ensuring a more efficient and accurate selection of candidates.",
            icon: "5",
        },
    ];

    const [activeId, setActiveId] = useState<number | null>(1); // Step 1 opened by default

    return (
        <section
            className="w-full bg-black py-10 px-10"
        >
            <div className="w-full max-w-[1400px] mx-auto flex flex-col items-center justify-center text-white">
                <div className="text-3xl md:text-5xl lg:text-7xl font-semibold mb-5">
                    Our Platform
                </div>
                <img src={image} alt="phone laptop" className="w-full h-full max-w-[600px]" />
                <div className="flex flex-col gap-3 max-w-xl mx-auto">
                    {stepsData.map((step) => {
                        return (
                            <div
                                onClick={() => setActiveId(step.id)}

                                className="flex flex-row bg-white rounded-xl items-center p-5 transition-all duration-300 ease-in-out cursor-pointer">
                                <div
                                    key={step.id}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-4">
                                            <div
                                                className={`text-2xl font-bold w-8 h-8 flex items-center justify-center rounded ${activeId == step.id ? "text-green-600" : "text-gray-800"
                                                    }`}
                                            >
                                                {step.icon}
                                            </div>
                                            <h3 className="font-semibold text-lg text-black">{step.title}</h3>
                                        </div>

                                    </div>
                                    {activeId == step.id && step.body && (
                                        <p className="text-gray-600 mt-3 ml-12">{step.body}</p>
                                    )}
                                </div>
                                {
                                    activeId == step.id && step.body && (
                                        <div className="ml-4 h-full">
                                            <ArrowIcon />
                                        </div>
                                    )
                                }
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandFeaturesOurPlatform;
